import { useState } from "react";
import { Color } from "../../Domain/Model/Color";
import ColorAPIDataSourceImpl from "../../Data/DataSource/API/ColorAPIDataSource";
import { ColorRepositoryImpl } from "../../Data/Repository/ColorRepositoryImpl";
import { GetColors } from "../../Domain/UseCase/GetColors";
import { CreateColor } from "../../Domain/UseCase/CreateColor";
import { RemoveColor } from "../../Domain/UseCase/RemoveColor";
import { UpdateColor } from "../../Domain/UseCase/UpdateColor";
import { ListBoxChangeEvent } from "primereact/listbox";

export default function LoginViewModel() {

    const [colors, setColors] = useState<Color[]>([]);

    const colorDataSourceImpl = new ColorAPIDataSourceImpl();
    const colorRepositoryImpl = new ColorRepositoryImpl(colorDataSourceImpl);

    const getColorsUseCase = new GetColors(colorRepositoryImpl);
    const createColorUseCase = new CreateColor(colorRepositoryImpl);
    const removeColorUseCase = new RemoveColor(colorRepositoryImpl);
    const updateColorUseCase = new UpdateColor(colorRepositoryImpl);

    async function getColors() {
        setColors(await getColorsUseCase.invoke());
    }

      async function createColor(data: Color) {
        try {
          const createdColor = await createColorUseCase.invoke(data);
          if(createdColor){
            console.log("enviado");
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
      }

      async function removeColor(id: string) {
        try {
          let removedColor = await removeColorUseCase.invoke(id);
          if(removedColor){
            console.log("eliminado");
           return removedColor;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }

      async function updateColor(data: Color) {
        try {
          let updatedColor = await updateColorUseCase.invoke(data);
          if(updatedColor){
            console.log("Actualizado");
           return updatedColor;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }


      function onChangeColor(e: ListBoxChangeEvent) {
        e.preventDefault();
        setColors(e.target.value);
      }
      
      return {
        getColors,
        createColor,
        removeColor,
        updateColor,
        onChangeColor,
        colors,
      };
}